import { render, staticRenderFns } from "./PressReleaseCard.vue?vue&type=template&id=112526d3&scoped=true&"
import script from "./PressReleaseCard.vue?vue&type=script&lang=js&"
export * from "./PressReleaseCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112526d3",
  null
  
)

export default component.exports